import { Box, styled } from '@mui/material';
import Grid from '@mui/material/Grid';

export const UserResourceGrid = styled(Grid)(({ theme }) => ({
  padding: '1rem',
  display: 'flex',
  justifyContent: 'space-between',
  minHeight: '3.1rem',
  backgroundColor: `${(theme.vars || theme).palette.subtleBackground} !important`,
  border: '1px solid !important',
  borderRadius: '.25rem !important',
  borderColor: `${(theme.vars || theme).palette.borderColor} !important`,
}));

export const UserTableWrapper = styled(Box)({
  marginTop: '5px',
});
